import ItineraryCard from "./ItineraryCard";

export const itineraryCard = {
    init:() => {
        const cardContainer = document.querySelector(".sd-itinerary-card__content");
        const showAllButtons = document.querySelectorAll(".sd-itinerary-card__add");
        new ItineraryCard(cardContainer, showAllButtons)
    }
}

export default itineraryCard